import { MatDialog } from '@angular/material/dialog';
import { Component, OnDestroy, Input } from '@angular/core';
import { ErrorStreamChange } from '../../models/$error.model';
import { AuthService } from '../../services/auth.service';
import { confirmPasswordReset, getAuth } from '@angular/fire/auth';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'reset-password-component',
    template: `
<div class="authenticate reset_page">
    <ng-container *ngIf="!password_changed; else reset_succeed">
        <h1 class="reset_title">Reset your password</h1>
        <div class="for_email">for <strong>{{email}}</strong></div>
        <form #resetForm="ngForm">
            <mat-form-field class="general">
                <input matInput type="password" id="password" name="password" [(ngModel)]="password" placeholder="Password" minlength="6" required (ngModelChange)="checkPassword()">
                <mat-error *ngIf="resetForm.controls['password']?.errors?.required">A password is required</mat-error>
                <mat-error *ngIf="resetForm.controls['password']?.errors?.minlength">Password with less than 6 characters</mat-error>
            </mat-form-field>
            <mat-form-field class="general">
                <input 
                  matInput type="password" 
                  name="conf_password" 
                  placeholder="Confirm password"
                  [(ngModel)]="conf_password"
                  (ngModelChange)="checkConfirmPassword()"
                  required>
                <mat-error *ngIf="resetForm.controls['conf_password']?.errors?.required">A confirmation password is required</mat-error>
            </mat-form-field>
            <div class="error" *ngIf="confirmError">Confirm password does not match</div>
            <div class="control">
                <button mat-button color="primary" [disabled]="resetForm.invalid || conf_password!=password" (click)="resetPassword()">Save</button>
            </div>
            <div class="error_message" *ngIf="error_message" [textContent]="error_message"></div>
        </form>
    </ng-container>
</div>
<ng-template #reset_succeed>
    <h1 class="reset_title">Password changed</h1>
    <div class="for_email">You can now sign in with your new password.</div>
    <div class="control">
        <button mat-button color="primary" routerLink="/login">Sign in</button>
    </div>
</ng-template>
`,
    styleUrls: [`./login.page.scss`],
    imports: [MatInputModule, MatFormFieldModule, MatButtonModule, FormsModule, CommonModule, ReactiveFormsModule],
    standalone: true
})
export class ResetPasswordComponent implements OnDestroy {

    public error_message = '';
    private login_subscription
    @Input('params') params;
    @Input('email') email;
    password = '';
    conf_password = '';
    confirmError = false
    password_changed = false;
    startedConfirmPassword = false

    constructor( public auth: AuthService, private dialog: MatDialog) {
        this.login_subscription = this.auth.$errors.subscribe((error: ErrorStreamChange) => {
            // console.log('error ', error);
            switch (error.code) {
                case 'auth/user-not-found':
                    this.error_message = 'Sorry, we don\'t have a user that matches the details you provided.';
                    break;
                case 'auth/wrong-password':
                    this.error_message = 'Sorry, the password you provided doesn\'t match our records.';
                    break;
                case 'auth/too-many-requests':
                    this.error_message = 'Too many unsuccessful login attmpts';
                    break;
                default:
                    this.error_message = error.data['message'];
                    break;
            }
        });
    }

    checkPassword() {
      if (this.startedConfirmPassword) this.checkConfirmPassword()
    }

    checkConfirmPassword() {
      this.startedConfirmPassword = true
      this.confirmError = this.password !== this.conf_password
    }

    async resetPassword() {
      if (this.params && this.params.mode === 'resetPassword') {
        confirmPasswordReset(getAuth(), this.params.oobCode, this.password).then(() => this.password_changed = true)
          .catch(error => {
              this.error_message = error.message;
          });
      }
    }


    ngOnDestroy() {
        this.login_subscription.unsubscribe();
    }
}
